import { render, staticRenderFns } from "./storeOrderCartDetail.vue?vue&type=template&id=356d6bf4&scoped=true"
import script from "./storeOrderCartDetail.vue?vue&type=script&lang=js"
export * from "./storeOrderCartDetail.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartDetail.vue?vue&type=style&index=0&id=356d6bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d6bf4",
  null
  
)

export default component.exports